// Apply domain method mixins onto ApiClient (B1.3).
type Constructor = new (...args: any[]) => object;

export function applyMixins<T extends Constructor>(baseCtor: T, ...mixins: Constructor[]): T {
  mixins.forEach((mixinCtor) => {
    Object.getOwnPropertyNames(mixinCtor.prototype).forEach((name) => {
      if (name === 'constructor') return;
      const desc = Object.getOwnPropertyDescriptor(mixinCtor.prototype, name);
      if (desc) Object.defineProperty(baseCtor.prototype, name, desc);
    });
  });
  return baseCtor;
}
